import ReportSection from "./ReportSection";
import NewsSection from "./NewsSection";
import ShowOffSection from "./ShowOffSection";
import ArticlesSection from "./ArticlesSection";
import ArticlesFeaturedSection from "./ArticlesFeatured";

import VideosSection from "../../blocks/Videos/VideosSection";

export default {
  ReportSection,
  NewsSection,
  ShowOffSection,
  VideosSection,
  ArticlesSection,
  ArticlesFeaturedSection,
};
